// extracted by mini-css-extract-plugin
export default {"imageWrapper":"XE-z","hovered":"YE-z","hoverImage":"ZE-z","mainImage":"_E-z","imageNoBackground":"aF-z","fullSizeImage":"bF-z"};